// src/client/components/OrderForm.jsx
import React, { useState } from 'react';
import { useCart } from '../../core/context/CartContext';
import { loadStripe } from '@stripe/stripe-js';
import { useAuthClient } from '../../core/context/AuthClientContext';

// ✅ Clé Stripe depuis variable d'environnement (plus de hardcode)
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const OrderForm = ({ onClose }) => {
  const { cartItems, getTotalPrice } = useCart();
  const { getToken, getUser } = useAuthClient();
  const token = getToken();
  const user = getUser();

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    comments: '',
    pointsToUse: 0
  });
  const [status, setStatus] = useState('');
  const totalPrice = getTotalPrice();

  const handleChange = (e) =>
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');

    const { name, phone, email, address, pointsToUse } = formData;

    if (!name.trim() || !phone.trim() || !email.trim() || !address.trim())
      return setStatus('Veuillez remplir tous les champs obligatoires.');
    if (!validateEmail(email))
      return setStatus('Veuillez entrer une adresse email valide.');
    if (!Object.keys(cartItems).length)
      return setStatus('Votre panier est vide.');
    if (pointsToUse > (user?.points || 0)) {
      return setStatus("Vous ne pouvez pas utiliser plus de points que vous n'en avez.");
    }

    const items = Object.values(cartItems).map(({ item, quantity }) => ({
      name: item.name,
      price: item.price,
      quantity,
    }));

    try {
      const stripe = await stripePromise;
      if (!stripe) {
        return setStatus('Erreur de configuration du paiement. Contactez le restaurant.');
      }

      // ✅ Récupère le token CSRF
      const clientKey = localStorage.getItem("selectedClient") || "le_resto_local";
      const csrfRes = await fetch(`${process.env.REACT_APP_API_URL}/api/csrf-token`, {
        method: 'GET',
        credentials: 'include',
        headers: { "x-client-key": clientKey }
      });
      const { csrfToken } = await csrfRes.json();

      // ✅ Lance la requête vers Stripe avec CSRF + clientKey
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/payment/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'X-CSRF-Token': csrfToken,
          'x-client-key': clientKey
        },
        credentials: 'include',
        body: JSON.stringify({
          items,
          customerInfo: formData,
        })
      });

      const session = await res.json();
      if (!session.id) throw new Error('Erreur lors de la création de la session Stripe.');

      await stripe.redirectToCheckout({ sessionId: session.id });

    } catch (err) {
      setStatus('Erreur lors du démarrage du paiement.');
    }
  };

  if (!token) {
    return (
      <div className="order-form-overlay" onClick={onClose}>
        <div className="order-form animated-fadein" onClick={(e) => e.stopPropagation()}>
          <button className="close-btn" onClick={onClose} aria-label="Fermer">×</button>
          <p className="alert alert-danger">Veuillez vous connecter pour passer une commande.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="order-form-overlay" onClick={onClose}>
      <form className="order-form animated-fadein" onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit}>
        <button type="button" className="close-btn" onClick={onClose} aria-label="Fermer">×</button>
        <h2>Valider la commande</h2>

        <label>Nom complet *<input name="name" value={formData.name} onChange={handleChange} required /></label>
        <label>Téléphone *<input name="phone" value={formData.phone} onChange={handleChange} required /></label>
        <label>Email *<input name="email" value={formData.email} onChange={handleChange} required /></label>
        <label>Adresse de livraison *<textarea name="address" value={formData.address} onChange={handleChange} required /></label>
        <label>Notes / Instructions<textarea name="comments" value={formData.comments} onChange={handleChange} /></label>

        <label>Utiliser mes points ?
          <input
            type="number"
            name="pointsToUse"
            value={formData.pointsToUse}
            min="0"
            max="10000"
            onChange={handleChange}
            placeholder="Ex: 100"
          />
        </label>

        {status && <p className={`alert ${status.includes('succès') ? 'alert-success' : 'alert-danger'}`}>{status}</p>}

        <div className="order-total mb-3">
          <strong>Total à payer :</strong> {totalPrice.toFixed(2)} €
        </div>

        <button type="submit" className="btn btn-primary w-100">Payer maintenant</button>
      </form>
    </div>
  );
};

export default OrderForm;